<!-- 三方推流设置界面 -->
<template>
  <div class="vmp-third-stream">
    <!-- 第三方推流 -->
    <div class="vmp-third-stream-box">
      <div class="vmp-third-stream-title">
        推流地址
        <span class="vmp-third-stream-subTitle">
          当直播下有多个正在进行的拉流，观众只能看到拉取的第一路流
        </span>
      </div>
      <div class="vmp-third-stream-modal" :class="'streamModal' + streamModal">
        <div class="title">发起模式</div>
        <vh-radio-group v-model="streamModal">
          <vh-radio :label="1">推流设置</vh-radio>
          <vh-radio :label="2">拉流设置</vh-radio>
        </vh-radio-group>
        <div class="input-item" v-show="streamModal == 1">
          <label>RTMP/URL</label>
          <div class="vmp-third-stream-modal-input readOnly">
            <span class="input" :title="thirdWatchWebUrl">{{ thirdWatchWebUrl }}</span>
            <span class="tool">
              <span title="复制" @click="doCopy(1)" class="vh-iconfont vh-line-copy"></span>
            </span>
          </div>
        </div>
        <div class="input-item" v-show="streamModal == 1">
          <label>播放路径/串流码</label>
          <div class="vmp-third-stream-modal-input readOnly">
            <span class="input" :title="thirdPlayUrl">{{ thirdPlayUrl }}</span>
            <span class="tool">
              <span title="复制" @click="doCopy(2)" class="vh-iconfont vh-line-copy"></span>
            </span>
          </div>
        </div>
        <div class="input-item" v-show="streamModal == 2">
          <label>
            <span class="required">*</span>
            拉流地址
          </label>
          <div
            class="vmp-third-stream-modal-input"
            :class="showRulePullUrl ? 'showRulePullUrl' : ''"
          >
            <vh-input v-model="pullUrl" placeholder="请输入拉流地址，支持rtmp、hls协议"></vh-input>
            <vh-button class="save-btn" type="text" @click="validatePullUrl">保存</vh-button>
            <span class="alert" v-show="showRulePullUrl">
              {{ pullUrl ? '无法访问指定频道，请仔细检查您的拉流地址' : '请输入拉流地址' }}
            </span>
          </div>
        </div>
        <div class="input-item">
          <label>拉流状态</label>
          <div class="vmp-third-stream-modal-input readOnly">
            <span class="input" :class="!!streamStatus ? 'success' : 'fail'">
              {{ !!streamStatus ? '正在拉流' : '未检测到拉流' }}
            </span>
            <span class="tool">
              <span
                title="刷新"
                @click="getThirdPushStreamStatus"
                class="vh-iconfont vh-line-refresh-right"
              ></span>
            </span>
          </div>
        </div>
        <div class="separator"></div>
        <template v-if="streamModal == 1">
          <div class="title">使用第三方推流</div>
          <div class="content">
            <p>1.在第三方工具中添加RTMP URL与串流码;</p>
            <p>2.使用第三方工具推流;</p>
            <p style="color: #fb3a32">
              3.进入到主持人发起端，点击右上角头像 → 点击【第三方发起】后，再点击【开始直播】按钮;
            </p>
            <p>4.播放路径/串流码的有效期为7天，建议定期更新。</p>
            <p>5.第三方推流已开始，请勿通过「直播间设计器」修改视频区布局</p>
            <p style="color: #fb3a32">
              6.使用第三方推流软件进行无延迟直播时，为避免因第三方推流软件的编码配置导致延迟增加，需要配置相关设置用以保证无延迟直播体验

              <a
                style="color: #436dfa; margin-left: 10px"
                href="https://saas-doc.vhall.com/opendocs/show/1746"
                target="_blank"
              >
                详细教程
              </a>
            </p>
          </div>
          <div class="title">
            使用设备推流
            <a href="https://saas-doc.vhall.com/opendocs/show/1666" target="_blank">详细教程</a>
          </div>
          <div class="content">
            <p>1.在设备中添加RTMP URL与串流码;</p>
            <p>2.使用设备推流;</p>
            <p style="color: #fb3a32">
              3.进入到主持人发起端，点击右上角头像 → 点击【第三方发起】后，再点击【开始直播】按钮
            </p>
            <p class="notice">注意事项：结束直播后请同步停止您的设备推流，避免影响下次直播</p>
          </div>
        </template>
        <template v-else>
          <div class="title">使用第三方拉流</div>
          <div class="content">
            <p>
              1.在第三方工具中获取拉流地址，并填写到本平台拉流地址中;填写完成后，需要点击【保存】方可生效
            </p>
            <p style="color: #fb3a32">
              2.进入到主持人发起端，点击右上角头像 → 点击【第三方发起】后，再点击【开始直播】按钮
            </p>
          </div>
          <div class="title">注意事项</div>
          <div class="content">
            <p>
              拉流开始前，请沟通视频流资源方，将我们的拉流服务器IP列入白名单，否则有可能造成拉流失败。
            </p>
          </div>
        </template>
      </div>
    </div>
    <begin-play :webinarId="$route.params.str"></begin-play>
  </div>
</template>
<script>
  import { copy } from '@/utils/utils';
  import regRule from '@/utils/reg-rule.js';
  import beginPlay from '@/components/beginBtn';
  export default {
    name: 'VmpThirdStream',
    data() {
      return {
        thirdWatchWebUrl: '',
        thirdPlayUrl: '',
        streamModal: 1,
        pullUrl: '',
        showRulePullUrl: false,
        //是否有流：0-无，1-有
        streamStatus: 0
      };
    },
    components: {
      beginPlay
    },
    beforeCreate() {},
    computed: {},
    watch: {
      pullUrl(val) {
        if (val) {
          this.showRulePullUrl = false;
        }
      }
    },
    created() {
      this.getThirdPushStream();
      this.getThirdPushStreamStatus();
      this.getStreamPullAddress();
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
      getStreamPullAddress() {
        this.$fetch('getStreamPullAddress', { webinar_id: this.$route.params.str }).then(res => {
          if (res.code == 200) {
            this.pullUrl = res.data.dest_url;
          }
        });
      },
      getThirdPushStream() {
        this.$fetch('getStreamPushAddress', { webinar_id: this.$route.params.str }).then(res => {
          if (res.code == 200) {
            this.thirdPlayUrl = res.data.stream_code;
            this.thirdWatchWebUrl = res.data.stream_address;
          }
        });
      },
      //刷新房间内流状态
      getThirdPushStreamStatus() {
        this.$fetch('getLiveStreamStatus', {
          webinar_id: this.$route.params.str
        }).then(res => {
          if (res.code == 200) {
            this.streamStatus = res.data.status;
          }
        });
      },
      doCopy(type) {
        copy(type == 1 ? this.thirdWatchWebUrl : this.thirdPlayUrl);
        this.$message({
          message: '复制成功！',
          showClose: true,
          type: 'success',
          customClass: 'zdy-info-box'
        });
      },
      //校验拉流地址非法性
      validatePullUrl() {
        if (!this.pullUrl) {
          this.showRulePullUrl = true;
        } else {
          const reg = regRule.pullUrl;
          if (reg.test(this.pullUrl)) {
            this.showRulePullUrl = false;
            this.$fetch('setStreamPullAddress', {
              webinar_id: this.$route.params.str,
              dest_url: this.pullUrl
            }).then(res => {
              if (res.code == 200) {
                this.$message({
                  message: '保存成功！',
                  showClose: true,
                  type: 'success',
                  customClass: 'zdy-info-box'
                });
              }
            });
          } else {
            this.showRulePullUrl = true;
          }
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  .vmp-third-stream {
    &-box {
      margin: 0 auto;
      width: 100%;
      height: 100%;
    }
    &-title {
      // width: 820px;
      margin: 0 auto;
      padding-bottom: 10px;
      font-weight: 600;
      overflow: auto;
      font-size: 20px;
      line-height: 28px;
      color: #1a1a1a;
    }
    &-subTitle {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #999999;
      margin-left: 8px;
    }
    &-modal {
      // width: 720px;
      margin: 0 auto;
      background: #ffffff;
      border-radius: 4px;
      padding: 24px;
      box-sizing: border-box;
      color: #1a1a1a;
      &.streamModal2 {
        .input-item label {
          min-width: 68px;
          width: 68px;
        }
        .required {
          color: #fb3a32;
        }
        input {
          border-color: #ccc;
        }
        .vh-input__inner:focus,
        .vh-textarea__inner:focus,
        .vh-input__inner:hover,
        .vh-textarea__inner:hover {
          border-color: #999;
        }
      }
      .title {
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        color: #1a1a1a;
        position: relative;
        padding-left: 11px;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 4px;
          height: 14px;
          width: 3px;
          background-color: #fb3a32;
        }
        a {
          color: #436dfa;
          margin-left: 6px;
          font-weight: 400;
        }
      }
      .vh-radio-group {
        margin-top: 24px;
        .vh-radio {
          margin-right: 35px;
        }
        .vh-radio__label {
          color: #666;
        }
        .vh-radio__input.is-checked + .vh-radio__label {
          color: #1a1a1a;
        }
        .vh-radio__inner {
          width: 16px;
          height: 16px;
        }
        .vh-radio__inner::after {
          width: 8px;
          height: 8px;
        }
      }
      .input-item {
        margin-top: 24px;
        display: flex;
        align-items: center;
        color: #1a1a1a;
        label {
          min-width: 105px;
          width: 105px;
          text-align: right;
          font-size: 14px;
          line-height: 20px;
          margin-right: 12px;
        }
      }
      &-input {
        width: 555px;
        display: flex;
        align-items: center;
        height: 40px;
        box-sizing: border-box;
        position: relative;
        .save-btn {
          margin-left: 5px;
        }
        &.readOnly {
          border: 1px solid #cccccc;
          padding: 0 0 0 12px;
          background: #f7f7f7;
          border-radius: 4px;
        }
        &.showRulePullUrl {
          input {
            border: 1px solid #fb3a32;
          }
          .alert {
            color: #fb3a32;
            font-size: 12px;
            position: absolute;
            bottom: -17px;
          }
        }
        .input {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 100%;
          &.success {
            color: #436dfa;
          }
          &.fail {
            color: #fb3a32;
          }
        }
        .tool {
          min-width: 29px;
          padding-right: 12px;
          text-align: right;
          .vh-iconfont {
            cursor: pointer;
            color: #666;
            &:hover {
              color: #1a1a1a;
            }
          }
        }
      }
      .separator {
        width: 100%;
        height: 40px;
      }
      .content {
        margin-top: 8px;
        margin-bottom: 24px;
        padding: 20px;
        background: #f7f7f7;
        border-radius: 4px;
        line-height: 22px;
        font-size: 14px;
        &:last-child {
          margin-bottom: 0;
        }
        .notice {
          margin-top: 5px;
          color: #666;
        }
      }
    }
  }
</style>
